module.exports = __webpack_public_path__ + "d53e3912ceb7c9326058d6a714cb50d4.svg";